import { render } from "./sales-product-list.vue?vue&type=template&id=c7ed1918"
import script from "./sales-product-list.vue?vue&type=script&lang=js"
export * from "./sales-product-list.vue?vue&type=script&lang=js"

import "./sales-product-list.vue?vue&type=style&index=0&id=c7ed1918&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__